var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcWorkOutline(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 48,
    viewBox: "0 0 51 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.3158 10.1053V5.05263H20.2105V10.1053H30.3158ZM5.05263 15.1579V42.9474H45.4737V15.1579H5.05263ZM45.4737 10.1053C48.2779 10.1053 50.5263 12.3537 50.5263 15.1579V42.9474C50.5263 45.7516 48.2779 48 45.4737 48H5.05263C2.24842 48 0 45.7516 0 42.9474L0.0252631 15.1579C0.0252631 12.3537 2.24842 10.1053 5.05263 10.1053H15.1579V5.05263C15.1579 2.24842 17.4063 0 20.2105 0H30.3158C33.12 0 35.3684 2.24842 35.3684 5.05263V10.1053H45.4737Z",
    fill: "#0859A4"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcWorkOutline);
export default __webpack_public_path__ + "static/media/ic-work-outline.d1c789d3.svg";
export { ForwardRef as ReactComponent };